import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const StaffAuthContext = createContext(null);
const TOKEN_KEY = "spa_staff_token";

export function StaffAuthProvider({ children }) {
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) {
      setLoading(false);
      return;
    }
    axios
      .get(`${API}/staff/me`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => setStaff(r.data.staff))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setStaff(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await axios.post(`${API}/staff/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setStaff(r.data.staff);
    return r.data.staff;
  }, []);

  const logout = useCallback(async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    try {
      if (t) {
        await axios.post(`${API}/staff/logout`, null, { headers: { Authorization: `Bearer ${t}` } });
      }
    } catch (err) {
      console.error("Staff logout request failed:", err);
    }
    localStorage.removeItem(TOKEN_KEY);
    setStaff(null);
  }, []);

  const authHeader = useCallback(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    return t ? { Authorization: `Bearer ${t}` } : {};
  }, []);

  const value = useMemo(
    () => ({ staff, loading, login, logout, authHeader }),
    [staff, loading, login, logout, authHeader],
  );

  return <StaffAuthContext.Provider value={value}>{children}</StaffAuthContext.Provider>;
}

export const useStaffAuth = () => useContext(StaffAuthContext);
